import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/vehicleType', request)
}

async function post(request) {
    return await postMethod('/api/vehicleType', request)
}

async function put(id, request) {
    return await putMethod(`/api/vehicleType/${id}`, request)
}

export {get, post, put}
